import AddButton from "components/ui/Button/AddButton/AddButton";
import Heading from "components/ui/Heading/Heading";
import PaginationSearch from "components/ui/InputTypes/InputSearch/PaginationSearch/PaginationSearch";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { baseResources, baseResourceActions } from "routes/enum";

import { SCENARIO_ACTIONS } from "../enum";

const { KB_AGENT_GUIDE_SCENARIO } = baseResources;
const { CREATE } = baseResourceActions;
const { CREATE_SCENARIO } = SCENARIO_ACTIONS;

const ScenariosHeader = ({
    handleActionModal,
    handleSearch,
    searchIsLoading,
    clearSearch,
    defaultValue,
}) => {
    const handleCreateScenario = () => {
        handleActionModal(CREATE_SCENARIO);
    };

    return (
        <>
            <div className='agentaguides__heading'>
                <Heading
                    headingText={"Scenarios"}
                    headingSubText={"Add & change scenarios"}
                />
                <div className='agentaguides__heading--filter'>
                    <PaginationSearch
                        {...{
                            handleSearch,
                            searchIsLoading,
                            clearSearch,
                            defaultValue,
                        }}
                    />
                    <ComponentAccessControl
                        baseResources={[`${CREATE}_${KB_AGENT_GUIDE_SCENARIO}`]}>
                        <AddButton
                            btnText={"Create New Scenario"}
                            onClick={handleCreateScenario}
                        />
                    </ComponentAccessControl>
                </div>
            </div>
        </>
    );
};

export default ScenariosHeader;
